module.exports = __webpack_public_path__ + "img/2382.80155ae6.gif";